


export default {



    set (key,val) {
        try {
            localStorage.setItem(key, JSON.stringify(val))
        }catch(e){
            return ''
        }
    },




    get (key) {
        try {
            return JSON.parse(localStorage.getItem(key))
        }catch(e){
            return ''
        }
        
    },




    remove (key) {
        try{
            localStorage.removeItem(key)
        }catch(e){
            return ''
        }
        
    }
}